import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMannheim() {
  return (
    <CityPageTemplate
      city="Mannheim"
      slug="mannheim"
      intro="Mannheim als Wirtschaftszentrum der Metropolregion Rhein-Neckar bietet ideale Voraussetzungen für Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Mannheim: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
